import React from 'react'

export default ({src, ...rest}) => {
    return (<iframe width="560" height="315" src={src} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen {...rest}></iframe>)
}